<script setup lang="ts">
import type { ContestGameReward, MessageTemplate } from '@/types/types'

const props = defineProps<{
  reward: ContestGameReward
  messageTemplate: MessageTemplate
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'update:reward', reward: ContestGameReward): void
}>()

const { t } = useI18n()

const editingReward = ref<ContestGameReward>({
  ...props.reward
})

const saveReward = () => {
  emit('update:reward', editingReward.value)
  emit('close')
}
</script>

<template>
  <BaseModal
    :heading-title="t('pages.contests.modal.editLostReward.title')"
    is-open
    :show-footer="false"
    @close="emit('close')"
  >
    <div class="flex flex-col gap-4">
      <AppFormInput
        id="numberOfPoint"
        v-model="editingReward.name"
        :label="t('pages.contests.contestsCreatePage.prices.form.loose.losingTileText')"
      />
    </div>

    <div class="mt-10 flex items-center justify-center gap-2">
      <Button variant="outline" class="flex-1" @click="emit('close')">
        {{ t('global.words.cancel') }}
      </Button>
      <Button variant="default-primary" class="flex-1" @click="saveReward">
        {{ t('global.words.submit') }}
      </Button>
    </div>
  </BaseModal>
</template>
